import React from "react";
import DefaultTemplate from "templates/DefaultTemplate";
import { Link } from "react-router-dom";
import { Link as MuiLink } from "@mui/material";
import { Box, Typography } from "@mui/material";
import styles from "./MainPage.styled";
import menuItems from "./constants";

const MainPage = () => {
  return (
    <DefaultTemplate>
      <Box sx={styles.itemsWrap}>
        {menuItems.map((item) => (
          <Box key={item.title}>
            <MuiLink to={item.path} component={Link} sx={styles.link}>
              <Box sx={styles.iconWrap}>
                <item.icon />
              </Box>
              <Typography>{item.title}</Typography>
            </MuiLink>
          </Box>
        ))}
      </Box>
    </DefaultTemplate>
  );
};

export default MainPage;
